import React from "react";

function Footer(){
    return(
        <div class="text-center p-6 bg-black footer">
        <span class="text-white">&copy; 2022 Copyright -Abdul Rub </span>
        {/* <a class="link-underline text-white font-bold" href="https://rahulkarda.netlify.app">Abdul Rub</a> */}
      </div>
    )
}


export default Footer